import React, { useContext, useState } from "react";
import PrimaryButton from "../common/PrimaryButton";
import joinUsImg1 from "../../assets/images/joinUsImg1.webp";
import joinUsImg2 from "../../assets/images/joinUsImg2.webp";
import joinUsImg3 from "../../assets/images/joinUsImg3.webp";
import logo from "../../assets/svgs/techqillalogo.svg";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

const JoinUs = () => {
  const [hoveredImage, setHoveredImage] = useState(null);
  const dataContext = useContext(AuthContext);
  const navigate = useNavigate();

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <section
      className={`${
        theme === "dark" ? "bg-white" : "bg-black"
      } relative w-full flex justify-center items-center`}
    >
      <div className="w-full px-5 sm:px-20 py-8 sm:py-28 max-w-screen-2xl mx-auto">
        <div className="flex justify-between flex-col-reverse sm:flex-row items-center">
          <div className="py-10 sm:py-0 sm:p-[50px] sm:w-[50%]">
            <div className="size-[250px] flex justify-center items-center sm:size-[480px] border border-[#F20B97] rounded-full relative positive-animate-spin1">
              <div className="size-[50px] sm:size-28 absolute -left-5 sm:-left-10 bottom-24 rounded-full overflow-hidden -animate-spin1">
                <img
                  src={joinUsImg1}
                  onMouseEnter={() => setHoveredImage(joinUsImg1)}
                  alt=""
                  className="object-cover object-center border-4 border-white rounded-full size-14 sm:size-28"
                />
              </div>
              <div className="size-[50px] sm:size-28 absolute -right-5 sm:-right-10 bottom-32 rounded-full overflow-hidden -animate-spin1">
                <img
                  src={joinUsImg2}
                  onMouseEnter={() => setHoveredImage(joinUsImg2)}
                  alt=""
                  className="object-cover object-center border-4 border-white rounded-full  size-14 sm:size-28"
                />
              </div>
              <div className="p-10 sm:p-20 size-[150px] sm:size-auto flex justify-center items-center border border-[#F20B97] rounded-full relative">
                <div className="size-[50px] sm:size-28 absolute -top-5 sm:-top-10 rounded-full overflow-hidden  -animate-spin1">
                  <img
                    src={joinUsImg3}
                    onMouseEnter={() => setHoveredImage(joinUsImg3)}
                    alt=""
                    className="object-cover size-14 sm:size-28 object-center -animate-spin border-4 border-white rounded-full"
                  />
                </div>
                <div className="size-[80px] sm:size-44 bg-white rounded-full flex justify-center items-center relative z-10 -animate-spin">
                  <img
                    src={logo}
                    alt=""
                    className="w-[50px] sm:w-[100px] -animate-spin1"
                  />
                </div>
              </div>
            </div>
            {hoveredImage && (
              <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div
                  onMouseLeave={() => setHoveredImage(null)}
                  className="bg-white p-5 rounded-lg shadow-lg relative"
                >
                  <button
                    className="absolute top-2 right-2 text-xl font-bold text-gray-700"
                    onClick={() => setHoveredImage(null)}
                  >
                    &times;
                  </button>
                  <img
                    src={hoveredImage}
                    alt=""
                    className=" sm:w-[700px] sm:h-[500px] rounded-lg object-cover"
                  />
                </div>
              </div>
            )}
          </div>
          <div className="max-w-2xl sm:my-20 relative sm:w-[50%]">
            <h2
              className={`${
                theme === "dark" ? "text-dark" : "text-white"
              } transition-all duration-500 text-3xl bricolage-grotesque-bold  mb-4 sm:mb-8 sm:text-5xl text-center sm:text-left`}
            >
              Want to Join Our Team?
            </h2>
            <p
              className={`${
                theme === "dark" ? "text-dark" : "text-white"
              } transition-all duration-500 mt-4 text-lg font-gtAmerica text-center sm:text-left`}
            >
              Are you a creative storyteller with a passion for making an
              impact? We're seeking talented content creators to collaborate on
              exciting projects and grow in a supportive environment. If you
              value creativity, innovation, and excellence, apply now and let's
              create something amazing together!
            </p>
            <div className="flex justify-center sm:justify-start">
              <PrimaryButton
                onClick={() => {
                  navigate("/careers");
                }}
                className={`${
                  theme === "dark"
                    ? "bg-white !text-black hover:!text-white hover:bg-secondary border-secondary hover:shadow-[0_0_10px_2px] hover:shadow-secondary"
                    : "border-secondary bg-white !text-black hover:shadow-[0_0_10px_2px] hover:shadow-secondary inset-0 hover:!text-white hover:bg-secondary"
                } relative z-20 border mt-5`}
              >
                View current openings
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinUs;
